<!--新增权限模板model-->
<template>
    <div>
        <el-form label-width="80px">
            <el-form-item label="模板名称">
                <el-input v-model="name" placeholder="请输入名称"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button @click="handlePowerTemplateName"
                           :loading="$parentInfo.dialog_AddPowerTemplate.button_loading">创建模板名称
                </el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
    export default {
        name: "Dialog_AddPowerTemplate",
        data() {
            return {
                name: '',
                title: '创建模板',
            }
        },
        created() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
        },
        methods: {
            handlePowerTemplateName() {
                this.$parentInfo.anotherAuthorityList.rightLoading = true;
                this.$parentInfo.authorityList.leftLoading = true;
                this.$parentInfo.dialog_AddPowerTemplate.button_loading = true;
                this.$wApi.send(this.$parentInfo.path, 'store_powerTemplate', {
                    'name': this.name
                });
            },

        }
    }
</script>

<style scoped>
</style>